import log from 'loglevel';

import Vue from './utils/setup_vue';
import App from './App.vue';
import store from './store';
import { logLevel, defaultRecipe } from './utils/config';

log.setDefaultLevel(logLevel);

if (defaultRecipe && defaultRecipe.platform) {
  /* If we already have a (partial) recipe, load it and
   * skip the initial Project Details screen.
   */
  store.commit('setRecipe', defaultRecipe);
  store.commit('navigate', 'next');
  /* Get the recipe code immediately */
  store.dispatch('uploadRecipe');
}

new Vue({
  render: (h) => h(App),
  store,
}).$mount('#app');

const preloaderElement = document.querySelector('div#preloader');
if (preloaderElement) preloaderElement.remove();
